export default __webpack_public_path__ + "static/media/nft-19.f7fcc4de.png";